import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { createUseStyles } from 'react-jss';

import { Separator } from '../../products/common/separator';
import { ReviewNoticeCard } from '../common/review_notice_card';
import { FindInsurerNotice } from '../common/find_insurer_notice';
import { ProviderLogoGrid } from '../common/provider_logo_grid';
import { NoQuotesSummary } from '../common/no_quotes_summary';
import { AlexanderNoResults } from '../common/alexander_no_results';

const useStyles = createUseStyles((theme) => ({
    sorryContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    noQuotesSummaryContainer: {
        width: '49.3rem'
    },
    title: {
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize['3xl'],
        color: theme.colors.primary800,
        marginBottom: theme.spacing[8]
    },
    subTitle: {
        fontSize: theme.fontSize.xl
    },
    alexander: {
        height: theme.spacing[116]
    },
    reviewNoticeCardContainer: {
        marginTop: theme.spacing[16]
    },
    reviewNoticeCardText: {
        marginBottom: '2rem',
        fontSize: theme.fontSize.base,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey800,
        lineHeight: '2rem'
    },
    separator: {
        marginTop: '3.2rem',
        marginBottom: '3.3rem'
    },
    findInsurerNoticeContainer: {
        marginTop: '2.4rem',
        textAlign: 'left'
    },
    logoTitle: {
        textAlign: 'left',
        color: theme.colors.grey800,
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.semibold,
        marginBottom: '3.3rem'
    },
    logo: {
        width: '8rem',
        height: '5.5rem',
        marginBottom: '2.8rem'
    }
}));

const EmptyStateFullPageSm = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <>
            <div className={classes.sorryContainer}>
                <NoQuotesSummary className={classes.noQuotesSummaryContainer} titleClassName={classes.title} subTitleClassName={classes.subTitle} />
                <AlexanderNoResults className={classes.alexander} />
            </div>
            <ReviewNoticeCard className={classes.reviewNoticeCardContainer} textClassName={classes.reviewNoticeCardText} />
            <Separator type="horizontal" className={classes.separator} />
            <ProviderLogoGrid titleClassName={classes.logoTitle} logoClassName={classes.logo} />
            <FindInsurerNotice className={classes.findInsurerNoticeContainer} />
        </>
    );
};

export { EmptyStateFullPageSm };
